import React from "react";
import { tableColumnsWidths } from "variables";

export const ProductListTableRowSkeleton = () => (
  <>
    <td style={{ width: tableColumnsWidths.nameWidth }}>
      <div className="shortloadingLine col-12 rounded"></div>
    </td>
    <td style={{ width: tableColumnsWidths.orderCodeWidth }}>
      <div className="shortloadingLine col-8 rounded"></div>
    </td>
    <td style={{ width: tableColumnsWidths.quantityWidth }}>
      <div className="shortloadingLine col-8 rounded"></div>
    </td>
    <td style={{ width: tableColumnsWidths.unitPriceWidth }}>
      <div className="shortloadingLine col-8 rounded"></div>
    </td>
    <td style={{ width: tableColumnsWidths.totalPriceWidth }}>
      <div className="shortloadingLine col-8 rounded"></div>
    </td>
    <td style={{ width: tableColumnsWidths.priceGroupWidth }}>
      <div className="shortloadingLine col-8 rounded"></div>
    </td>
  </>
);
